/**
 * [sc-48692] «Da saldare» sulla riga dell'ordine (`realTotalPrice`) è il
 * totale meno quanto già pagato (`deposit`). Quando il pagato cambia senza
 * ricaricare l'elenco, il rimanente cala di altrettanto.
 */
export function aggiornaDaSaldare(quote, nuovoPagato) {
  const dopo = Number(nuovoPagato);
  if (!quote || !Number.isFinite(dopo)) return;
  const prima = Number(quote.deposit) || 0;
  quote.deposit = dopo;
  quote.realTotalPrice = (Number(quote.realTotalPrice) || 0) - (dopo - prima);
}

/**
 * [sc-48692] Quanto va restituito al cliente quando ha pagato più del dovuto,
 * per esempio dopo una modifica che ha abbassato il totale. Riceve il
 * rimanente (dovuto meno pagato): sotto zero è un credito del cliente.
 * Il rimborso avviene fuori dal gestionale; qui lo si rende visibile.
 */
export function daRestituire(rimanente) {
  const r = Number(rimanente);
  if (!Number.isFinite(r) || r > -0.005) return 0;
  return Number((-r).toFixed(2));
}

/**
 * [sc-48692] Pagato e con la consegna iniziata: l'ordine non si modifica più.
 * Gemello di `ordineChiusoAlleModifiche` nell'API, che comunque rifiuta.
 */
const STATI_CONSEGNA_INIZIATA = [
  "Consegna Parziale",
  "In consegna",
  "Consegnato",
];

export function ordineNonModificabile(quote) {
  return (
    quote?.payment_state === "Pagato" &&
    STATI_CONSEGNA_INIZIATA.includes(quote?.state)
  );
}
